import React, {useEffect, useState} from 'react';
import './style.scss';
import {GameCoins} from '../GameCoins';
import {APP_GAME_KWAMI} from '../../../../constants/kwami';
import profileCardCoin from "../../../../../images/profile-card-coin.png";
import {CommonUtil} from "../../../../utils/CommonUtil";

const GameGuideStep1 = () => <>
  <div className="app-game-guide--description">
    Одна игра длится<br/>
    60 секунд.<br/>
    Чем больше квами ты<br/> поймаешь, тем больше<br/> баллов заработаешь
  </div>
</>

const GameGuideStep2 = () => <div className="app-game-guide--description">
  <p>
    Тапай на Пухх, Тикки,<br/> Плага и&nbsp;зарабатывай<br/> баллы
  </p>
  <div className="app-game-guide--kwami">
    <div className="app-game-guide--trix app-game-item_success">
      <div className="app-game-item--coins">
        <span className="app-game-item--value">+{APP_GAME_KWAMI.banix.coins}</span>
        <img className="app-game-item--icon" src={profileCardCoin} alt={''}/>
      </div>
      <img src={APP_GAME_KWAMI.banix.image} alt=""/>
    </div>
    <div className="app-game-guide--plag app-game-item_success">
      <div className="app-game-item--coins">
        <span className="app-game-item--value">+{APP_GAME_KWAMI.plag.coins}</span>
        <img className="app-game-item--icon" src={profileCardCoin} alt={''}/>
      </div>
      <img src={APP_GAME_KWAMI.plag.image} alt=""/>
    </div>
    <div className="app-game-guide--tikki app-game-item_success">
      <div className="app-game-item--coins">
        <span className="app-game-item--value">+{APP_GAME_KWAMI.tikki.coins}</span>
        <img className="app-game-item--icon" src={profileCardCoin} alt={''}/>
      </div>
      <img src={APP_GAME_KWAMI.tikki.image} alt=""/>
    </div>
  </div>
</div>;

const GameGuideStep3 = () => <div className="app-game-guide--description">
  <p>
    Тапай на Поллен. Она<br/> заморозит игру<br/> и таймер на&nbsp;5&nbsp;секунд,<br/> и&nbsp;ты сможешь спокойно<br/> собрать всех квами<br/> на экране!
  </p>
  <div className="app-game-guide--kwami">
    <div className="app-game-guide--pollen app-game-item_success">
      <img src={APP_GAME_KWAMI.pollen.image} alt=""/>
    </div>
  </div>
</div>;

const GameGuideStep4 = () => <div className="app-game-guide--description">
  <p>Не тапай на Шуппу, он<br/> обнулит твои баллы!</p>
  <div className="app-game-guide--kwami">
    <div className="app-game-guide--xuppu app-game-item_danger">
      <img src={APP_GAME_KWAMI.xuppu.image} alt=""/>
    </div>
  </div>
</div>;

const GameGuideProgress = ({step}) => <div className="app-game-guide--progress">
  <div className={'app-game-guide--progress-step' + (1 < step ? ' app-active' : '') + (1 === step ? ' app-loading' : '')}></div>
  <div className={'app-game-guide--progress-step' + (2 < step ? ' app-active' : '') + (2 === step ? ' app-loading' : '')}></div>
  <div className={'app-game-guide--progress-step' + (3 < step ? ' app-active' : '') + (3 === step ? ' app-loading' : '')}></div>
  <div className={'app-game-guide--progress-step' + (4 === step ? ' app-loading' : '')}></div>
</div>;

export const GameGuide = ({onCompleted}) => {
  const [step, setStep] = useState(1);

  useEffect(() => CommonUtil().ymReachGoal('ladybug_game_view_guide'), []);

  useEffect(() => {
    if (1 <= step && step <= 4) {
      console.log('[Ladybug.Guide] > step #' + step);
      window.setTimeout(() => setStep(prev => prev + 1), 6000);
    } else {
      console.log('[Ladybug.Guide] > completed');
      onCompleted();
    }
  }, [step]);

  return <div className="app-game-guide">
    <header className="app-game--header">
      <div className="app-game-timer">01:00</div>
      <GameCoins coins={100}/>
    </header>
    <GameGuideProgress step={step}/>
    {1 === step && <GameGuideStep1/>}
    {2 === step && <GameGuideStep2/>}
    {3 === step && <GameGuideStep3/>}
    {4 === step && <GameGuideStep4/>}
  </div>
}
